import { createContext, useContext, useEffect, useState } from "react";

const PortalCtx = createContext(null);

const KEY = "ce_active_portal";

export function PortalProvider({ children }) {
  const [portal, setPortalState] = useState(() => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem(KEY) || null;
  });

  const setPortal = (p) => {
    setPortalState(p);
    if (p) localStorage.setItem(KEY, p);
    else localStorage.removeItem(KEY);
  };

  return <PortalCtx.Provider value={{ portal, setPortal }}>{children}</PortalCtx.Provider>;
}

export function usePortal() {
  return useContext(PortalCtx);
}

export const PORTAL_RENTALS = "rentals";
export const PORTAL_TRUCKING = "trucking";

export const PORTAL_LABELS = {
  rentals: "Vehicle Rentals & Leasing",
  trucking: "Trucking & Industrial Services",
};
